import { render } from "./LandingVersionSwitch.vue?vue&type=template&id=4372aac8"
import script from "./LandingVersionSwitch.vue?vue&type=script&lang=js"
export * from "./LandingVersionSwitch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__